import React from "react";

/**
 * RUMBLE.FUN brand mark — sticker wordmark.
 *
 *   <GnarlyWordmark size={22} />   — nav-scale (default)
 *   <GnarlyHeroMark size={64} />   — display-scale
 *
 * Dark sticker on the dark theme: cream border + cream offset shadow,
 * Bungee block caps for `rumble` with a `.fun` suffix in the same cream.
 * Slight -3deg tilt so it reads as something stuck on.
 */

function Sticker({ size }) {
  return (
    <span
      className="rumble-sticker"
      style={{
        fontSize: size,
        padding: `${Math.max(2, size * 0.18)}px ${Math.max(8, size * 0.55)}px ${Math.max(4, size * 0.22)}px`,
        borderWidth: Math.max(2, size * 0.11),
        boxShadow: `${Math.max(2, size * 0.18)}px ${Math.max(2, size * 0.18)}px 0 0 var(--pm-border)`,
      }}
    >
      slurp<span className="rumble-sticker__suffix">.gg</span>
    </span>
  );
}

export function GnarlyWordmark({ size = 22, ...rest }) {
  return (
    <span style={{ display: "inline-block", lineHeight: 1, ...(rest.style || {}) }} {...rest}>
      <Sticker size={size} />
    </span>
  );
}

export function GnarlyHeroMark({ size = 64, ...rest }) {
  return (
    <span style={{ display: "inline-block", lineHeight: 1, ...(rest.style || {}) }} {...rest}>
      <Sticker size={size} />
    </span>
  );
}

// Back-compat aliases — older imports continue compiling while we migrate.
export const BoomWordmark = GnarlyWordmark;
export const BoomHeroMark = GnarlyHeroMark;
export const BoomMark = GnarlyWordmark;
export const BoomBigMark = GnarlyHeroMark;
export const WickWordmark = GnarlyWordmark;
export const KilnMark = GnarlyWordmark;
export const KilnWordmark = GnarlyWordmark;
export const DegenLogo = GnarlyWordmark;
export const DegenWordmark = GnarlyWordmark;
